import PubSub from "underpub-js";
import Swiper from "swiper";
import { Navigation, Pagination, Controller } from "swiper/modules";

Swiper.use([Navigation, Pagination, Controller]);

var ContentTextMediaSlider = function(options) {

	this.options = {
		$el: false,
		baseClass: 'mol-ContentTextMediaSlider',
	};

	$.extend(true, this.options, options);
};
ContentTextMediaSlider.prototype.init = function() {


	var self = this;
	self.$mediaSlides = self.options.$el.find(`.${self.options.baseClass}__mediaWrapper`);
	self.$contentSlides = self.options.$el.find(`.${self.options.baseClass}__content`);
	self.$arrowPrev = self.options.$el.find(`.${self.options.baseClass}__arrow--prev`);
	self.$arrowNext = self.options.$el.find(`.${self.options.baseClass}__arrow--next`);
	self.initCarousel();
	
	
};

ContentTextMediaSlider.prototype.initCarousel = function() {
	var self = this;
	
	let swiperOptions = {

		loop: false,
		slidesPerView: 1,

		// arrows

		breakpoints: {
			560: {
				slidesPerView: 1,
			},
			768: {
				slidesPerView: 1,
			},
			1024: {
				slidesPerView: 1,
			},
			1280: {
				slidesPerView: 1,
			}
		},

		
	};
	let swiperOptionsContent = {
		 direction:"horizontal",
		loop: false,
		
		// initialSlide: self.numberOfSlides,
		
		slidesPerView: 1,

		// arrows
		navigation: {
		  nextEl: self.$arrowNext[0],
		  prevEl: self.$arrowPrev[0],
		},
		breakpoints: {
			560: {
				slidesPerView: 1,
			},
			768: {
				slidesPerView: 1,
			},
			1024: {
				slidesPerView: 1,
			},
			1280: {
				slidesPerView: 1,
			}
		},

		
	};
	self.swiper = new Swiper(self.$mediaSlides[0], swiperOptions);
	self.swiperContent = new Swiper(self.$contentSlides[0], swiperOptionsContent);
	// self.swiper.controller.control = self.swiperContent;
	self.swiperContent.controller.control = self.swiper;
}

export default ContentTextMediaSlider;
